import { useSamarthDashboardSelector } from '../hooks/useSamarthDashboardContext';

export const useKpiData = (kpiKey) => {
    const data = useSamarthDashboardSelector((state) =>
        kpiKey ? state.dashboardData[kpiKey] : state.dashboardData
    );

    const isLoading = useSamarthDashboardSelector((state) =>
        kpiKey
            ? state.dashboardData.isLoading[kpiKey]
            : state.dashboardData.isLoading.all
    );

    const error = useSamarthDashboardSelector((state) =>
        kpiKey
            ? state.dashboardData.error[kpiKey]
            : state.dashboardData.error.all
    );

    const filters = useSamarthDashboardSelector((state) => ({
        mapfilters: state.filters.mapFilters,
        globalFilters: state.filters.globalFilters,
        actionFilters: state.filters.actionFilter,
        currentTDP: state.filters.tdp,
        currentWeek: state.filters.weekFilter
    }));

    return {
        data,
        isLoading,
        error,
        filters,
    };
};